/**
 * @author techirdliu
 * @created 2015/12/7
 *
 * 二次验证流程可参考流程图：https://www.processon.com/view/link/567a13ade4b0e5b40348c8fc
 * 密码：nmc_v5
 *
 * 上述注释上线压缩的时候会去除
 *
 */


var __DEBUG__ = false;

var $ = window.$;


import TwoFactorSCode from '../widget/twofactorscode'
import util from '../utils/util';


var TWO_FACTOR_REQUIRED = 45;
var TWO_FACTOR_VERIFY_FAILED = 47;

/**
 * 包裹之前的 net._ajax() 方法
 * */
var _ajax = null;

/**
 * ajaxWrapper - nmc 内部用于包裹 net.send() 方法的，不对外提供调用
 *
 * 在进行 ajax 请求之前，根据相关参数判断该请求是否敏感操作，是敏感操作的话需要验证之后才能继续调用
 * */
export function _netAjaxWrapper(ajax) {
    _ajax = ajax;

    return function (url, data, method, cgiCallback, global) {
        if (__DEBUG__) {
            console.log('net._ajax(', url, data, method, cgiCallback, global, ')');
        }
        var send, sendWithSCode, detectDangerCgi, detectTwofactorVerify;

        // CGI 请求原样发送，回调函数为拦截器
        send = function (detector) {
            _ajax(url, data, method, detector, global);
        };

        // 所有 CGI 请求首次发送使用的拦截器，判断是否为敏感操作
        detectDangerCgi = function (response) {
            // CGI 无返回，不处理
            if (!response) {
                cgiCallback(response);
                return;
            }
            // CGI 被相应为敏感操作，弹出二次验证输入安全码重新发送
            if (response.code == TWO_FACTOR_REQUIRED) {
                TwoFactorSCode.show().then(sendWithSCode);
            }
            // 非敏感操作调用原本的 CGI 回调
            else {
                cgiCallback(response);
            }
        };

        // 得到用户输入的安全码之后，禁用输入对话框的按钮，并且带上安全码重发 CGI，
        // 此时 CGI 的回调改为判断二次验证是否通过
        sendWithSCode = function (scode) {
            TwoFactorSCode.disable(true);
            util.cookie.set('tw_scode', scode);
            send(detectTwofactorVerify);
        };

        // 判断二次验证是否通过，不通过的话会有特定的返回码
        detectTwofactorVerify = function (response) {
            // tw_scode 每次验证只使用一次，验证之后删除
            util.cookie.del('tw_scode');

            if (response.code == TWO_FACTOR_VERIFY_FAILED) {
                TwoFactorSCode.disable(false);

                var nopassCode = response.data && response.data.retcode;

                var errorMessage = {
                    '1263': '动态密码错误',
                    '1264': '该组密码已使用过，请输入新的动态密码'
                }[nopassCode] || '服务器错误，请稍后重试';

                TwoFactorSCode.retry(errorMessage).then(sendWithSCode);
            }
            // 验证成功，隐藏二次验证对话框，并且调用原本的 CGI 回调
            else {
                TwoFactorSCode.hide();
                cgiCallback(response);
            }
        };

        // 发送请求
        send(detectDangerCgi);
    }
}


function _requestTwoFactorSCode() {
    return TwoFactorSCode.show();
}

